var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/modules/_an-object.js
// module id = 87
// module chunks = 48 49 50